<div class="chart">
    <canvas baseChart [data]="pieChartData" [labels]="pieChartLabels" [chartType]="pieChartType"
        [options]="pieChartOptions" [colors]="pieChartColors" [legend]="pieChartLegend" width="400">
    </canvas>
</div>
